export enum AlteracaoStatus {
  PENDENTE = 'PENDENTE',
  ALTERADO = 'ALTERADO'
}
